import styled from 'styled-components';

const SegmentDetailsPanel = styled.div`
    z-index: 2;
    pointer-events: all;
    background-color: transparent;
    justify-self: stretch;
    padding: 4px;
    grid-column: sidebar-end / page-end;
    grid-row: segment-details-top / segment-details-bottom;
    width: 100%;

    @media (max-width: 1452px) {
        grid-column: sidebar-start / page-end;
        padding: 0 8px 8px 8px;
        justify-self: flex-start;
        width: 100%;
    }
`;

export default SegmentDetailsPanel;
